import { BCMSDate, useStateManager } from "@bcm-dev/bcms-vite";
import { TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView, WidgetContainer, WidgetView } from 'components/shared';
import { NoEntriesTableRow } from 'components/shared/views/TableView/components/NoEntriesTableRow';
import React from 'react';
import "./mobile.css";

/**
 * @function AlertHistoryWidget
 * @return {React.Component}
 * @exported true
 * @description description
 */

export default function AlertHistoryWidget(props) {
  const { data } = useStateManager();
  const widgetID = "alertHistoryWidget";
  const alerts = data[widgetID].alertHistory;
  const hasAlerts = alerts.length > 0;
  const alertRows = alerts.reduce((acc, item, index) => {
    if(item.id !== undefined) acc.push(<AlertHistoryTableRow dataPoint={ `Current_Alerts_Widget` } key={ item.id } alert={ item }/>);
    return acc;
  }, []);

  return(
    <WidgetContainer className="alert-history-widget">
          <WidgetView dataPoint={ `Alert_History_Widget_Title` } text="Alert History">
            <TableView className="alert-history-table">
              <TableColumnContainer>
                <TableColumnView text="Send Date" icon="ArrowDownIcon" />
                <TableColumnView text="Message" />
                <TableColumnView text="Sent To" />
              </TableColumnContainer>
              { hasAlerts && alertRows }
              { !hasAlerts && <NoEntriesTableRow colSpan="3" text="There are no notifications." /> }
            </TableView>
          </WidgetView>
        </WidgetContainer>
  );
}

/**
 * @function AlertHistoryTableRow
 * @return {React.Component}
 * @exported false
 * @description description
 */

function AlertHistoryTableRow(props) {
  const alert = props.alert ?? {};
  const dataPoint = props.dataPoint ?? "";
  const createdDate = `${ BCMSDate.init(alert.sendDate).format("m/d/Y") }`;
  const message = alert.message;

  return(
    <TableItemContainer className="alert-history-table-row">
        <TableItemTextView className="date-column" text={ createdDate } />
        <TableItemTextView className="message-column truncate-text" text={ alert.message } />
        <TableItemTextView className="email-column truncate-text" text={ alert.type === "email" ? alert.userAccount.emailAddress : alert.userAccount.phoneNumber } />
    </TableItemContainer>
  );
}